package pages.landing

import components.routing.ProtectedRoutingProps
import csstype.*
import ics.materialUI.extensions.alignItems
import ics.materialUI.extensions.justifyContent
import mui.material.Grid
import mui.material.Typography
import mui.material.styles.TypographyVariant
import mui.system.sx
import react.FC

val LandingPage = FC<ProtectedRoutingProps>("LandingPage") { props ->
    Grid {
        container = true
        alignItems = "center"
        justifyContent = "center"

        sx {
            height = 100.pct
            width = 100.pct
            alignItems = AlignItems.center
            justifyContent = JustifyContent.center

        }

        Grid {
            item = true

            Typography {
                variant = TypographyVariant.h4

                +"Welcome here ${props.session.username}"
            }
        }
    }
}